import moment from "moment";
import { REL_PLAN } from "./structure";
moment.locale("pl");

export const isoDateFormat = "Y-MM-DD";
const weekDayFormat = "dddd";
const dayOfTheMonthFormat = "Do";
const dayAndMonthFormat = "Do MMM";
const dayWithYearFormat = "Do MMM Y";
const monthFormat = "MMMM";
const monthWithYearFormat = "MMMM Y";
const enDash = "–";

export function toMomentJSUnit(unit) {
  return unit === "week" ? "isoweek" : unit;
}

export function formatDate(dateSpec, primary = true) {
  const [unit, date] = dateSpec.split(":");
  switch (unit) {
    case "day":
      return primary ? formatDayPrimary(date) : formatDaySecondary(date);
    case "week":
      return primary ? formatWeekRelative(date) : formatWeekAbsolute(date);
    case "month":
      return primary ? formatMonth(date) : "";
    default:
      return date;
  }
}

export function formatDateItem(item, primary = true) {
  if (!item?._id) return "invalid date";
  const unit = item._id.split(":")[0];
  switch (unit) {
    case "day":
      return primary ? formatDayPrimary(item.name) : formatDaySecondary(item.name);
    case "week":
      return primary
        ? formatWeekRelativeMiejscownik(item.name)
        : formatWeekAbsolute(item.name);
    case "month":
      return primary ? "Some day " + formatMonth(item.name) : "";
    default:
      return item.name;
  }
}

// Mutates `now` argument.
function formatDayPrimary(date, now = moment()) {
  const dayStart = moment(date);
  const offset = moment.duration(dayStart.diff(now.startOf("day")));
  switch (offset.asDays()) {
    case -1:
      return "Wczoraj";
    case 0:
      return "Dzisiaj";
    case 1:
      return "Jutro";
    default:
      return formatDayAbsolute(date);
  }
}

// Mutates `now` argument.
function formatDaySecondary(date, now = moment()) {
  const dayStart = moment(date);
  const offset = moment.duration(dayStart.diff(now.startOf("day")));
  switch (offset.asDays()) {
    case -1:
      return formatDayAbsolute(date) + ", " + dayStart.format(weekDayFormat);
    case 0:
      return formatDayAbsolute(date) + ", " + dayStart.format(weekDayFormat);
    case 1:
      return formatDayAbsolute(date) + ", " + dayStart.format(weekDayFormat);
    default:
      return dayStart.format(weekDayFormat);
  }
}

// Mutates `now` argument.
function formatDayAbsolute(date, now = moment()) {
  const dayStart = moment(date);
  return dayStart.format(
    dayStart.year() === now.year() ? dayAndMonthFormat : dayWithYearFormat,
  );
}

// Mutates `now` argument.
function formatWeekRelative(date, now = moment()) {
  const weekStart = moment(date);
  const offset = moment.duration(weekStart.diff(now.startOf("isoWeek")));
  const offsetInWeeks = Math.round(offset.asWeeks());
  switch (offsetInWeeks) {
    case -1:
      return "poprzedni tydzień";
    case 0:
      return "ten tydzień";
    case 1:
      return "następny tydzień";
    default:
      return offsetInWeeks < 0
        ? `${offsetInWeeks * -1} tygodni(e) temu`
        : `za ${offsetInWeeks} tygodni(e)`;
  }
}

// Mutates `now` argument.
function formatWeekRelativeMiejscownik(date, now = moment()) {
  const weekStart = moment(date);
  const offset = moment.duration(weekStart.diff(now.startOf("isoWeek")));
  const offsetInWeeks = Math.round(offset.asWeeks());
  switch (offsetInWeeks) {
    case -1:
      return "Kiedyś w poprzednim tygodniu";
    case 0:
      return "Kiedyś w tym tygodniu";
    case 1:
      return "Kiedyś w następnym tygodniu";
    default:
      return offsetInWeeks < 0
        ? `${offsetInWeeks * -1} tygodni(e) temu`
        : `za ${offsetInWeeks} tygodni(e)`;
  }
}

// Mutates `now` argument.
function formatWeekAbsolute(date, now = moment()) {
  const weekStartDay = moment(date);
  const lastWeekDay = weekStartDay.clone().add(6, "day");
  let result =
    weekStartDay.month() === lastWeekDay.month()
      ? weekStartDay.format(dayOfTheMonthFormat)
      : weekStartDay.format(dayAndMonthFormat);

  result += enDash + lastWeekDay.format(dayAndMonthFormat);
  if (weekStartDay.year() !== now.year()) {
    result += " " + lastWeekDay.year();
  }
  return result;
}

// Mutates `now` argument.
function formatMonth(date, now = moment()) {
  const dayStart = moment(date);
  return dayStart.format(
    dayStart.year() === now.year() ? monthFormat : monthWithYearFormat,
  );
}

export function resolveCurrent(input) {
  const [unit, date] = input.split(":");
  if (date === "current") {
    return unit + ":" + moment().startOf(toMomentJSUnit(unit)).format("Y-MM-DD");
  }
  return input;
}

export function repeatingDoesntMakeSense(task) {
  if (!task.plannedFor) {
    return true;
  } else {
    if (task.repeat.increment == undefined || task.repeat.unit == undefined) return true;
    const timeValues = {
      day: 1,
      week: 7,
      month: 30,
      year: 365,
      backlog: Infinity,
    };
    const repeatTime = task.repeat.increment * timeValues[task.repeat.unit];
    const plannedForScope = timeValues[task.plannedFor.parentClass];
    return repeatTime < plannedForScope;
  }
}

export function calcRepeatDate(item) {
  const [unit, date] = item[REL_PLAN].key.split(":");
  let newDate = moment(date).add(item.repeat.increment, item.repeat.unit);
  let now = moment();
  if (newDate.isBefore(now)) {
    now._f = newDate._f;
    newDate = now;
  }
  if (unit == "week") {
    newDate = newDate.startOf("isoWeek");
  }
  if (unit == "month") {
    newDate = newDate.startOf("month");
  }
  // keep original format
  return unit + ":" + newDate.format(isoDateFormat);
}

export function nowTimestamp() {
  return moment.utc().valueOf()
}